import { Link } from "react-router-dom";
import { Phone, Mail, Instagram } from "lucide-react";
import { CONTACTS, SOCIALS } from "@/data";
import Reveal from "@/components/Reveal";

export default function Footer() {
  return (
    <footer id="contact" className="relative bg-black border-t border-white/10 pt-28 md:pt-40 pb-10" data-testid="contact-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal>
          <span className="overline">[ Get in touch ]</span>
          <h2 className="mt-6 font-display font-semibold tracking-tighter text-[16vw] md:text-[12vw] leading-[0.85]">
            LET&apos;S <span className="text-purple">TALK</span>
          </h2>
        </Reveal>

        <div className="mt-20 grid md:grid-cols-3 gap-12 border-t border-white/10 pt-14">
          <div>
            <p className="overline mb-6">Direct line</p>
            <ul className="space-y-5">
              {CONTACTS.map((c) => (
                <li key={c.phone}>
                  <a
                    href={`tel:${c.phone.replace(/-/g, "")}`}
                    data-testid={`contact-phone-${c.name.split(" ")[0].toLowerCase()}`}
                    className="group flex items-center gap-3 text-white hover:text-lime transition-colors duration-300"
                  >
                    <Phone size={16} className="text-lime" />
                    <span className="font-body">
                      <span className="block text-sm text-white/50">{c.name}</span>
                      <span className="font-mono text-lg">{c.phone}</span>
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="overline mb-6">Email</p>
            <a
              href={`mailto:${SOCIALS.email}`}
              data-testid="contact-email"
              className="flex items-center gap-3 text-white hover:text-lime transition-colors duration-300 font-mono whitespace-nowrap text-sm md:text-base"
            >
              <Mail size={16} className="text-lime shrink-0" />
              {SOCIALS.email}
            </a>
          </div>

          <div>
            <p className="overline mb-6">Social</p>
            <div className="space-y-4">
              <a
                href={`https://instagram.com/${SOCIALS.instagram}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-instagram"
                className="flex items-center gap-3 text-white hover:text-lime transition-colors duration-300 font-mono"
              >
                <Instagram size={16} className="text-lime" />
                @{SOCIALS.instagram}
              </a>
              <a
                href={`https://tiktok.com/@${SOCIALS.tiktok}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-tiktok"
                className="flex items-center gap-3 text-white hover:text-lime transition-colors duration-300 font-mono"
              >
                <span className="w-4 text-center text-lime font-bold text-sm">t</span>
                @{SOCIALS.tiktok}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-24 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img
              src="/logo.png"
              alt="Aero Detail Lab"
              className="h-14 w-auto"
            />
          </div>
          <p className="font-mono text-xs text-white/40 uppercase tracking-[0.15em]">
            © {new Date().getFullYear()} Aero Detail Lab Ltd / Aviation Aesthetics &amp; Precision Care
          </p>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="font-mono text-xs text-white/40 hover:text-lime transition-colors duration-300 uppercase tracking-[0.15em]"
          >
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
